import React, { useState, useEffect } from "react";
import Content from "../layout/content/Content";
import Head from "../layout/head/Head";
import { Card, Spinner, Alert } from "reactstrap";
import {
  Block,
  BlockDes,
  BlockHead,
  BlockHeadContent,
  BlockTitle,
  BackTo,
  Icon,
  Button,
  Row,
  Col,
  PreviewAltCard,
} from "../components/Component";
import { Empty } from 'antd';
import { baseURLs } from '../utils/Constants';
import { getAxiosHeaders } from "../utils/Utils";
import { Link } from "react-router-dom";
import axios from 'axios';
import Header from "./components/purchase-order/Header";
import Body from "./components/purchase-order/Body";

const PurchaseOrderDetails = ({ history, match }) => {
  const [sm, updateSm] = useState(false);
  const [loading, setLoading] = useState(true);
  const [businessID, setBusinessID] = useState("");
  const [businessInfo, setBusinessInfo] = useState({});
  const [orderNumber, setOrderNumber] = useState("...");
  const [orderDetails, setOrderDetails] = useState({
    business_id: '',
    currency: '',
    order_id: '',
    order_number: '',
    order_type: '',
    target: '',
    expected_delivery_date: '',
    issue_date: '',
    has_supplier: 'no',
    supplier_info: {
      supplier_name: '',
      phone_number: '',
      email: '',
      other_info: ''
    },
    items: [],
    status: '',
    order_status: '',
    sub_total_amount: '',
    delivery_amount: '',
    discount_amount: '',
    tax_amount: '',
    total_amount: '',
    amount_paid: '',
    balance_due: '',
    payment_log: [],
    order_log: [],
    note: '',
    issued_by: '',
    created_at: ''
  });
  const [errorMessage, setErrorMessage] = useState("");

  const getPurchaseOrderDetails = (businessInfo, orderID) => {
    setLoading(true);
    axios.get(baseURLs.API_URL + `/purchase-orders/${orderID}`, {
      params: {
        business_id: businessInfo.business_id
      },
      headers: getAxiosHeaders().headers
    })
    .then((response) => {
      if (response.status === 204) {
        setErrorMessage('Order not found');
      } else {
        let responseInfo = response.data;
        let orderInfo = responseInfo.data.order_info;
        let _orderDetails = orderDetails;
  
        _orderDetails.business_id = businessInfo.business_id;
        _orderDetails.currency = businessInfo.currency;
  
        _orderDetails.order_id = orderID;
        _orderDetails.order_number = orderInfo.order_number;
        _orderDetails.order_type = orderInfo.order_type;
        _orderDetails.target = orderInfo.target;
        _orderDetails.expected_delivery_date = orderInfo.expected_delivery_date;
        _orderDetails.issue_date = orderInfo.issue_date;
        _orderDetails.has_supplier = orderInfo.has_supplier;
        _orderDetails.supplier_info = orderInfo.supplier_info;
        _orderDetails.items = orderInfo.items;
        _orderDetails.status = orderInfo.status;
        _orderDetails.order_status = orderInfo.order_status;
        _orderDetails.sub_total_amount = orderInfo.sub_total_amount;
        _orderDetails.discount_amount = orderInfo.discount_amount;
        _orderDetails.delivery_amount = orderInfo.delivery_amount;
        _orderDetails.tax_amount = orderInfo.tax_amount;
        _orderDetails.total_amount = orderInfo.total_amount;
        _orderDetails.amount_paid = orderInfo.amount_paid;
        _orderDetails.balance_due = orderInfo.balance_due;
        _orderDetails.note = orderInfo.note;
        _orderDetails.issued_by = orderInfo.issued_by;
        _orderDetails.payment_log = orderInfo.payment_log.length > 1 ? orderInfo.payment_log.reverse() : orderInfo.payment_log;
        _orderDetails.order_log = orderInfo.order_log.length > 1 ? orderInfo.order_log.reverse() : orderInfo.order_log;
        _orderDetails.created_at = orderInfo.created_at;
  
        setOrderDetails({..._orderDetails});
        setOrderNumber(orderInfo.order_number);
      }
      setLoading(false);
    }).catch((error) => {
      try{
        let errorResponse = error.response.data;

        let errorMessage = 'Error: Could not connect to server';
        if(errorResponse.hasOwnProperty("error")){
          errorMessage = errorResponse.error;
        }

        setErrorMessage(errorMessage);
        setLoading(false);
      }catch(e){
        console.log(e);
        // history.push(`${process.env.PUBLIC_URL}/server-offline`);
      }
    });
  }

  useEffect(() => {
    setLoading(true);
    const _businessID = parseInt(match.params.businessID, 10);
    const orderID = match.params.orderID;
    if ( Number.isInteger(_businessID) && orderID ) {
      localStorage.setItem('current_business_id', _businessID);
      let businesses = JSON.parse(localStorage.getItem('my_businesses'));
      let currentBusiness = businesses?.find((business) => business.business_id == _businessID);
      
      if(currentBusiness == undefined || null || ""){
        history.push(`${process.env.PUBLIC_URL}/not-found`);
        return;
      }

      setBusinessInfo({...currentBusiness});
      setBusinessID(_businessID);
      getPurchaseOrderDetails(currentBusiness, orderID);
    } else {
      history.push(`${process.env.PUBLIC_URL}/not-found`);
      return;
    }
  }, [match.params.business]);

  return (<React.Fragment>
    <Head title="Purchase Order Details" />
    <Content>
    {
      loading ?
      <Block className="nk-block-middle nk-auth-body text-center wide-xs">
        <div className="inner-pre-loader">
          <Spinner  color="dark" />          
        </div>
      </Block>
      :
      <>
        <BlockHead className="mb-4" size="sm">
          <div className="nk-block-between">
            <BlockHeadContent>
              <BlockDes className="text-soft">
                <p>{businessInfo.name}</p>
              </BlockDes>
              <BlockTitle page tag="h3">
                <span>Purchase Order Details</span>
                <span className="fw-normal ms-1">#{orderNumber}</span>
              </BlockTitle>
              
            </BlockHeadContent>
            <BlockHeadContent>
              <div className="toggle-wrap nk-block-tools-toggle">
                <Button
                  className={`btn-icon btn-trigger toggle-expand me-n1 ${sm ? "active" : ""}`}
                  onClick={() => updateSm(!sm)}
                >
                  <Icon name="more-v"></Icon>
                </Button>
                <div className="toggle-expand-content" style={{ display: sm ? "block" : "none" }}>
                  <ul className="nk-block-tools g-3">
                    <li>
                      <BackTo className="mb-3" history={history} link={`/purchase-orders/b/${businessID}`} icon="arrow-left" type="button">Go Back</BackTo>
                    </li>
                  </ul>
                </div>
              </div>
            </BlockHeadContent>
          </div>
        </BlockHead>
        <Block className="wide-sm m-auto">
          {
            errorMessage ?
            <Card className="card-bordered">
              <div className="card-inner">
                <div className="text-center m-5">
                  <div className="price-plan-media"><Empty image="https://gw.alipayobjects.com/zos/antfincdn/ZHrcdLPrvN/empty.svg" imageStyle={{height: 60}} description={false} /></div>
                  <div className="price-plan-info">
                    <h5 className="title fw-normal">Purchase order not found</h5>
                    <span>The purchase order you are looking for could not be found.</span>
                    <p className="text-soft">If you need help, you can reach us on our <a href={baseURLs.LIVE_CHAT}>live chat</a>.</p>
                  </div>
                  <div className="price-plan-action">
                    <Link to={`${process.env.PUBLIC_URL}/purchase-orders/b/${businessID}`}>
                      <button className="btn btn-outline-primary">Go to Purchase Orders</button>
                    </Link>                    
                  </div>
                </div>
              </div>
            </Card>
            :
            <Card className="card-bordered">
              <Header headerInfo={orderDetails}  />
              <Body history={history} orderInfo={orderDetails} setOrderInfo={setOrderDetails} />
            </Card>
          }


        </Block>
      </>
    }
    </Content>
    
  </React.Fragment>)
}

export default PurchaseOrderDetails;